import React, {Component, PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import ReactDOM from 'react-dom';
import * as userActions from '../actions/user';
import PhotoView from '../components/map/PhotoView';
import ProgressBar from '../components/wiget/ProgressBar';
import MegaMenu from '../components/layout/MegaMenu';
import Account from '../components/Account';
import Feedback from '../components/popups/Feedback';
import Subscribe from '../components/popups/Subscribe';
import Review from '../components/popups/Review';
import * as toursActions from '../actions/tours';
import Helmet from "react-helmet";
import cookie from 'react-cookie';
import CookiesPolicy from "../components/popups/CookiesPolicy";


class App extends Component {

  constructor (props) {
    super(props);
    this.eventUndo = this.eventUndo.bind(this);
    this.eventRedo = this.eventRedo.bind(this);
  }

  componentWillUnmount () {
  }

  resizeWindow (actions, width) {
    //console.log(1111);
    actions.setMapConfig({width: width});
  }

  eventUndo (e) {
    e.preventDefault();
    this.props.undo();
  }

  eventRedo (e) {
    e.preventDefault();
    this.props.redo();
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.location && (nextProps.location.pathname != this.pathname)) {
      let encodedUrl = encodeURIComponent(this.props.user.host + nextProps.location.pathname);
      this.props.userActions.fetchSEO(encodedUrl);
      this.pathname = nextProps.location.pathname;
    }

    this.nextProps = nextProps;
  }


  componentWillMount () {
    let currency = cookie.load('currency');
    if (currency) {
      this.props.userActions.selectCurrency(currency);
    }

    this.props.userActions.whoAmI();

    if (this.props.location.query.slug) {
      this.props.userActions.setSlugVisible(true);
    }
  }

  componentDidMount () {
    let actions = this.props.userActions;

    //console.log('this.props.children');
    //console.log(this.props.children);

    this.wrapper = ReactDOM.findDOMNode(this.refs.wrap);
    this.wrapperWidth = this.wrapper.clientWidth;
    this.props.toursActions.setMapConfig({width: this.wrapper.clientWidth + 20});
    this.props.toursActions.loadLocations();
    //console.log('window', window);
    if (typeof window === 'object') {
      //console.log(window);
      let actions = this.props.toursActions;
      let wrapper = this.wrapper;
      window.onresize = function () {
        actions.setMapConfig({width: wrapper.clientWidth + 20});
      };
    }

    let user = this.props.user;

    let cookiesPolicyHide = cookie.load('cookiesPolicyHide');
    if (!cookiesPolicyHide) {
      actions.toggleCookiesPolicy();
    }

    setTimeout(function () {
      let subscribeHide = cookie.load('subscribeHide');
      let subscribeComplete = cookie.load('subscribeComplete');

      if (!user.email && !subscribeHide && !subscribeComplete) {
        actions.toggleSubscribe();
      }
    }, 180000);
  }

  componentWillUpdate () {
    this.wrapperWidth = this.wrapper.clientWidth;
  }

  componentDidUpdate () {
    if (this.props.loginPromise) {
      let actions = this.props.userActions;
      this.props.user.loginPromise.then(function (result) {

        actions.setLoginResult(result);
      });
    }
  }


  toggleReview () {
    this.props.userActions.toggleReview();
  }

  renderChildren (props) {
    return React.Children.map(props.children, child => {
      return React.cloneElement(child, {
        wrapperWidth: (this.wrapperWidth) ? this.wrapperWidth : 1000
      })
    })
  }

  render () {
    const {user} = this.props;

    let meta = [
      {"name": "description", "content": (user.seo.description) ? user.seo.description : ''}
    ];

    return (
      <div>
        <Helmet
          title={(user.seo.title) ? user.seo.title : ((user.translations['home__title']) ? user.translations['home__title'] : "BaikalNature")}
          meta={meta}
        />
        <ProgressBar/>
        <div className="wrap" ref="wrap">
          <div className={"application " + ((this.props.user.menuOpen) ? "main_blured" : "")}>
            <div className={((this.props.user.menuOpen) ? "main__black-background" : "")}></div>
            {!this.props.children && <Account/>}
            {this.props.children}
          </div>

          {this.props.photo &&
            <PhotoView width={this.wrapperWidth} photo={this.props.photo} index={this.props.mapPhotoIndex}
                       actions={this.props.toursActions}></PhotoView>
          }


          <MegaMenu/>
          <Feedback path={this.nextProps} translations={this.props.user.translations} open={this.props.user.feedbackOpen}
                    user={this.props.user} load={this.props.user.fetchMessage} actions={this.props.userActions}/>

          <Subscribe translations={this.props.user.translations} open={this.props.user.subscribeOpen} user={this.props.user}
                     load={this.props.user.fetchSubscribe} actions={this.props.userActions}/>

          <CookiesPolicy
            translations={this.props.user.translations}
            open={this.props.user.cookiesPolicyOpen}
            user={this.props.user}
            actions={this.props.userActions}/>

          <Review path={this.nextProps} translations={this.props.user.translations} open={this.props.user.reviewOpen} user={this.props.user}
                  load={this.props.user.fetchReview} actions={this.props.userActions}/>
        </div>
      </div>
    );
  }
}


App.need = [
  {action: toursActions.fetchFeaturedTours},
  {action: userActions.preloadTranslations},
  {action: toursActions.fetchDestinations},
  {action: toursActions.fetchActivities},
  {action: toursActions.fetchTypes},
  {action: toursActions.loadLocations},
  {action: toursActions.getTourMenu},
  {action: userActions.loadCurrency}
];


/*

 <label className="sidebar-toggle" onClick={this.eventToggleSidebar}></label>
 <label className="undo-button" onClick={this.eventUndo}>&lt;</label>
 <label className="redo-button" onClick={this.eventRedo}>&gt;</label>

 */
function mapStateToProps (state) {
  return {
    user: state.user,
    loginPromise: state.user.loginPromise,
    map: state.tours.map,
    photo: state.tours.photo,
    mapPhotoIndex: state.tours.mapPhotoIndex
  };
}


function mapDispatchToProps (dispatch) {
  return {
    toursActions: bindActionCreators(toursActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/common/containers/AccountApp.js